import { palette } from '@livable/saas-react-components';
import { makeStyles } from '@mui/styles';
const useCorrectionsDetailsStyles = makeStyles({
  alertButton: {
    border: "1px solid ".concat(palette.shades[300])
  },
  wrapper: {
    '& .MuiAccordion-root': {
      boxShadow: 'none'
    },
    '& .MuiAccordionSummary-expandIconWrapper': {
      position: 'absolute',
      top: '50%',
      right: '16px',
      margin: '-16px 0 0 0',
      '& path': {
        fill: '#4B617C'
      },
      '&.Mui-expanded': {
        transform: 'rotate(180deg)'
      }
    }
  },
  accordionWrapper: {
    borderTop: "1px solid ".concat(palette.shades[300])
  },
  billTableHeader: {
    width: '100%',
    alignItems: 'center',
    backgroundColor: palette.common.white,
    display: 'flex',
    padding: '16px 24px',
    position: 'relative'
  },
  billTableHeaderTitle: {
    marginLeft: '16px'
  },
  chip: {
    marginLeft: '5px'
  },
  corrected: {
    color: palette.success.main
  },
  correctedChip: {
    textDecoration: 'line-through'
  },
  correctionTrigger: {
    marginBottom: '5px',
    marginLeft: '5px',
    '& .MuiChip-root': {
      marginLeft: '5px'
    }
  },
  correctionTriggers: {
    alignItems: 'baseline',
    display: 'flex',
    flexDirection: 'column'
  },
  correctionTriggersBlock: {
    padding: '16px 24px'
  },
  original: {
    color: palette.error.main,
    textDecoration: 'line-through'
  },
  summaryBlock: {
    '& + &': {
      marginLeft: '24px',
      paddingLeft: '24px',
      borderLeft: "1px solid ".concat(palette.shades[300])
    }
  },
  summaryBlocks: {
    display: 'flex',
    alignContent: 'center'
  },
  summaryWrapper: {
    margin: '18px 32px'
  },
  utilityProviderDetails: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'space-between'
  }
});
export default useCorrectionsDetailsStyles;